// import { Component } from '@theme/component';
// import {
//   fetchConfig,
//   debounce,
//   onAnimationEnd,
//   prefersReducedMotion,
//   resetShimmer,
//   startViewTransition,
// } from '@theme/utilities';
// import { morphSection, sectionRenderer } from '@theme/section-renderer';
// import {
//   ThemeEvents,
//   CartUpdateEvent,
//   QuantitySelectorUpdateEvent,
//   CartAddEvent,
//   DiscountUpdateEvent,
// } from '@theme/events';
// import { cartPerformance } from '@theme/performance';

// /** @typedef {import('./utilities').TextComponent} TextComponent */

// /**
//  * A custom element that displays a cart items component.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
//  * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
//  * @property {TextComponent} cartTotal - The cart total.
//  *
//  * @extends {Component<Refs>}
//  */
// class CartItemsComponent extends Component {
//   #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

//   connectedCallback() {
//     super.connectedCallback();

//     document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.removeEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   /**
//    * Handles QuantitySelectorUpdateEvent change event.
//    * @param {QuantitySelectorUpdateEvent} event - The event.
//    */
//   #onQuantityChange(event) {
//     if (!(event.target instanceof Node) || !this.contains(event.target)) return;

//     const { quantity, cartLine: line } = event.detail;

//     // Cart items require a line number
//     if (!line) return;

//     if (quantity === 0) {
//       return this.onLineItemRemove(line);
//     }

//     this.updateQuantity({
//       line,
//       quantity,
//       action: 'change',
//     });
//     const lineItemRow = this.refs.cartItemRows[line - 1];

//     if (!lineItemRow) return;

//     const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
//     textComponent?.shimmer();
//   }

//   /**
//    * Handles the line item removal.
//    * @param {number} line - The line item index.
//    */
//   onLineItemRemove(line) {
//     this.updateQuantity({
//       line,
//       quantity: 0,
//       action: 'clear',
//     });

//     const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

//     if (!cartItemRowToRemove) return;

//     const rowsToRemove = [
//       cartItemRowToRemove,
//       // Get all nested lines of the row to remove
//       ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
//     ];

//     // If the cart item row is the last row, optimistically trigger the cart empty state
//     const isEmptyCart = rowsToRemove.length == this.refs.cartItemRows.length;

//     const template = document.getElementById('empty-cart-template');
//     if (isEmptyCart && template instanceof HTMLTemplateElement) {
//       const clone = document.importNode(template.content, true);

//       startViewTransition(() => {
//         this.replaceChildren(clone);
//       }, [this.isDrawer ? 'empty-cart-drawer' : 'empty-cart-page']);

//       return;
//     }

//     // Add class to the row to trigger the animation
//     rowsToRemove.forEach((row) => {
//       const remove = () => row.remove();

//       if (prefersReducedMotion()) return remove();

//       row.style.setProperty('--row-height', `${row.clientHeight}px`);
//       row.classList.add('removing');

//       // Remove the row after the animation ends
//       onAnimationEnd(row, remove);
//     });
//   }

//   /**
//    * Updates the quantity.
//    * @param {Object} config - The config.
//    * @param {number} config.line - The line.
//    * @param {number} config.quantity - The quantity.
//    * @param {string} config.action - The action.
//    */
//   updateQuantity(config) {
//     const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

//     this.#disableCartItems();

//     const { line, quantity } = config;
//     const { cartTotal } = this.refs;

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     const sectionsToUpdate = new Set([this.sectionId]);
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });

//     const body = JSON.stringify({
//       line: line,
//       quantity: quantity,
//       sections: Array.from(sectionsToUpdate).join(','),
//       sections_url: window.location.pathname,
//     });

//     cartTotal?.shimmer();

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then((response) => {
//         return response.text();
//       })
//       .then((responseText) => {
//         const parsedResponseText = JSON.parse(responseText);

//         resetShimmer(this);

//         if (parsedResponseText.errors) {
//           this.#handleCartError(line, parsedResponseText);
//           return;
//         }

//         const newSectionHTML = new DOMParser().parseFromString(
//           parsedResponseText.sections[this.sectionId],
//           'text/html'
//         );

//         // Grab the new cart item count from a hidden element
//         const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
//         const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

//         // Update data-cart-quantity for all matching variants
//         this.#updateQuantitySelectors(parsedResponseText);

//         this.dispatchEvent(
//           new CartUpdateEvent(parsedResponseText, this.sectionId, {
//             itemCount: newCartItemCount,
//             source: 'cart-items-component',
//             sections: parsedResponseText.sections,
//           })
//         );

//         morphSection(this.sectionId, parsedResponseText.sections[this.sectionId], { mode: this.isDrawer ? 'hydration' : 'full' });

//         this.#updateCartQuantitySelectorButtonStates();
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         this.#enableCartItems();
//         cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
//       });
//   }

//   /**
//    * Handles the discount update.
//    * @param {DiscountUpdateEvent} event - The event.
//    */
//   handleDiscountUpdate = (event) => {
//     this.#handleCartUpdate(event);
//   };

//   /**
//    * Handles the cart error.
//    * @param {number} line - The line.
//    * @param {Object} parsedResponseText - The parsed response text.
//    * @param {string} parsedResponseText.errors - The errors.
//    */
//   #handleCartError = (line, parsedResponseText) => {
//     const quantitySelector = this.refs.quantitySelectors[line - 1];
//     const quantityInput = quantitySelector?.querySelector('input');

//     if (!quantityInput) throw new Error('Quantity input not found');

//     quantityInput.value = quantityInput.defaultValue;

//     const cartItemError = this.refs[`cartItemError-${line}`];
//     const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

//     if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
//     if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

//     cartItemError.textContent = parsedResponseText.errors;
//     cartItemErrorContainer.classList.remove('hidden');
//   };

//   /**
//    * Handles the cart update.
//    *
//    * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
//    */
//   #handleCartUpdate = (event) => {
//     if (event instanceof DiscountUpdateEvent) {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//       return;
//     }
//     if (event.target === this) return;

//     const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
//     if (cartItemsHtml) {
//       morphSection(this.sectionId, cartItemsHtml);

//       // Update button states for all cart quantity selectors after morph
//       this.#updateCartQuantitySelectorButtonStates();
//     } else {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//     }
//   };

//   /**
//    * Disables the cart items.
//    */
//   #disableCartItems() {
//     this.classList.add('cart-items-disabled');
//   }

//   /**
//    * Enables the cart items.
//    */
//   #enableCartItems() {
//     this.classList.remove('cart-items-disabled');
//   }

//   /**
//    * Updates quantity selectors for all matching variants in the cart.
//    * @param {Object} updatedCart - The updated cart object.
//    * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
//    */
//   #updateQuantitySelectors(updatedCart) {
//     if (!updatedCart.items) return;

//     for (const item of updatedCart.items) {
//       const variantId = item.variant_id.toString();
//       const selectors = document.querySelectorAll(`quantity-selector-component[data-variant-id="${variantId}"]`);

//       for (const selector of selectors) {
//         const input = selector.querySelector('input[data-cart-quantity]');
//         if (!input) continue;

//         input.setAttribute('data-cart-quantity', item.quantity.toString());

//         // Update the quantity selector's internal state
//         if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
//           selector.updateCartQuantity();
//         }
//       }
//     }
//   }

//   /**
//    * Updates button states for all cart quantity selector components.
//    */
//   #updateCartQuantitySelectorButtonStates() {
//     for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
//       /** @type {any} */ (selector).updateButtonStates?.();
//     }
//   }

//   /**
//    * Gets the section id.
//    * @returns {string} The section id.
//    */
//   get sectionId() {
//     const { sectionId } = this.dataset;

//     if (!sectionId) throw new Error('Section id missing');

//     return sectionId;
//   }

//   /**
//    * @returns {boolean} Whether the component is a drawer.
//    */
//   get isDrawer() {
//     return this.dataset.drawer !== undefined;
//   }
// }

// if (!customElements.get('cart-items-component')) {
//   customElements.define('cart-items-component', CartItemsComponent);
// }


// import { Component } from '@theme/component';
// import {
//   fetchConfig,
//   debounce,
//   onAnimationEnd,
//   prefersReducedMotion,
//   resetShimmer,
//   startViewTransition,
// } from '@theme/utilities';
// import { morphSection, sectionRenderer } from '@theme/section-renderer';
// import {
//   ThemeEvents,
//   CartUpdateEvent,
//   QuantitySelectorUpdateEvent,
//   CartAddEvent,
//   DiscountUpdateEvent,
// } from '@theme/events';
// import { cartPerformance } from '@theme/performance';

// /** @typedef {import('./utilities').TextComponent} TextComponent */

// /**
//  * A custom element that displays a cart items component.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
//  * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
//  * @property {TextComponent} cartTotal - The cart total.
//  *
//  * @extends {Component<Refs>}
//  */
// class CartItemsComponent extends Component {
//   #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

//   /** @type {AbortController | null} */
//   #qtyDiscountFetch = null;

//   connectedCallback() {
//     super.connectedCallback();

//     document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.removeEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//     this.#qtyDiscountFetch?.abort();
//   }

//   /**
//    * Handles QuantitySelectorUpdateEvent change event.
//    * @param {QuantitySelectorUpdateEvent} event - The event.
//    */
//   #onQuantityChange(event) {
//     if (!(event.target instanceof Node) || !this.contains(event.target)) return;

//     const { quantity, cartLine: line } = event.detail;

//     // Cart items require a line number
//     if (!line) return;

//     if (quantity === 0) {
//       return this.onLineItemRemove(line);
//     }

//     this.updateQuantity({
//       line,
//       quantity,
//       action: 'change',
//     });
//     const lineItemRow = this.refs.cartItemRows[line - 1];

//     if (!lineItemRow) return;

//     const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
//     textComponent?.shimmer();
//   }

//   /**
//    * Handles the line item removal.
//    * @param {number} line - The line item index.
//    */
//   onLineItemRemove(line) {
//     this.updateQuantity({
//       line,
//       quantity: 0,
//       action: 'clear',
//     });

//     const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

//     if (!cartItemRowToRemove) return;

//     const rowsToRemove = [
//       cartItemRowToRemove,
//       // Get all nested lines of the row to remove
//       ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
//     ];

//     // If the cart item row is the last row, optimistically trigger the cart empty state
//     const isEmptyCart = rowsToRemove.length == this.refs.cartItemRows.length;

//     const template = document.getElementById('empty-cart-template');
//     if (isEmptyCart && template instanceof HTMLTemplateElement) {
//       const clone = document.importNode(template.content, true);

//       startViewTransition(() => {
//         this.replaceChildren(clone);
//       }, [this.isDrawer ? 'empty-cart-drawer' : 'empty-cart-page']);

//       return;
//     }

//     // Add class to the row to trigger the animation
//     rowsToRemove.forEach((row) => {
//       const remove = () => row.remove();

//       if (prefersReducedMotion()) return remove();

//       row.style.setProperty('--row-height', `${row.clientHeight}px`);
//       row.classList.add('removing');

//       // Remove the row after the animation ends
//       onAnimationEnd(row, remove);
//     });
//   }

//   /**
//    * Updates the quantity.
//    * @param {Object} config - The config.
//    * @param {number} config.line - The line.
//    * @param {number} config.quantity - The quantity.
//    * @param {string} config.action - The action.
//    */
//   updateQuantity(config) {
//     const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

//     this.#disableCartItems();

//     const { line, quantity } = config;
//     const { cartTotal } = this.refs;

//     const sectionsToUpdate = this.#sectionsToUpdate();

//     const body = JSON.stringify({
//       line: line,
//       quantity: quantity,
//       sections: sectionsToUpdate.join(','),
//       sections_url: window.location.pathname,
//     });

//     cartTotal?.shimmer();

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then((response) => {
//         return response.text();
//       })
//       .then(async (responseText) => {
//         const parsedResponseText = JSON.parse(responseText);

//         resetShimmer(this);

//         if (parsedResponseText.errors) {
//           this.#handleCartError(line, parsedResponseText);
//           return;
//         }

//         const newSectionHTML = new DOMParser().parseFromString(
//           parsedResponseText.sections[this.sectionId],
//           'text/html'
//         );

//         // Grab the new cart item count from a hidden element
//         const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
//         const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

//         // Update data-cart-quantity for all matching variants
//         this.#updateQuantitySelectors(parsedResponseText);

//         this.dispatchEvent(
//           new CartUpdateEvent(parsedResponseText, this.sectionId, {
//             itemCount: newCartItemCount,
//             source: 'cart-items-component',
//             sections: parsedResponseText.sections,
//           })
//         );

//         morphSection(this.sectionId, parsedResponseText.sections[this.sectionId], {
//           mode: this.isDrawer ? 'hydration' : 'full',
//         });

//         this.#updateCartQuantitySelectorButtonStates();

//         await this.#syncQuantityDiscount(parsedResponseText);
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         this.#enableCartItems();
//         cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
//       });
//   }

//   /**
//    * Applies or removes the multi-quantity discount code based on cart line quantities.
//    * @param {Object} cart - The cart payload from /cart/change.js
//    * @param {Array<{quantity: number}>} [cart.items]
//    * @param {Array<{code: string, applicable: boolean}>} [cart.discount_codes]
//    */
//   async #syncQuantityDiscount(cart) {
//     if (this.dataset.qtyDiscountEnabled !== 'true') return;

//     const discountCode = this.dataset.qtyDiscountCode?.trim();
//     if (!discountCode) return;

//     const threshold = parseInt(this.dataset.qtyDiscountThreshold || '2', 10);
//     const excludedProductIds = new Set(
//       (this.dataset.qtyDiscountExcludedProducts || '')
//         .split(',')
//         .map((id) => id.trim())
//         .filter(Boolean)
//     );
//     const qualifies =
//       Array.isArray(cart.items) &&
//       cart.items.some((item) => {
//         const variantTitle = (item.variant_title || '').toLowerCase().trim();
//         const excludedVariant = variantTitle === '2 bottle' || variantTitle === '3 bottle';
//         const excludedProduct = excludedProductIds.has(String(item.product_id));
//         return !excludedVariant && !excludedProduct && item.quantity >= threshold;
//       });

//     /** @type {string[]} */
//     const existingCodes = (cart.discount_codes || [])
//       .filter((discount) => discount.applicable)
//       .map((discount) => discount.code);

//     const codeIndex = existingCodes.findIndex((code) => code.toLowerCase() === discountCode.toLowerCase());
//     const hasCode = codeIndex !== -1;

//     if (qualifies && hasCode) return;
//     if (!qualifies && !hasCode) return;

//     /** @type {string[]} */
//     let nextCodes;
//     if (qualifies) {
//       nextCodes = [...existingCodes, discountCode];
//     } else {
//       nextCodes = existingCodes.filter((_, index) => index !== codeIndex);
//     }

//     if (this.#qtyDiscountFetch) {
//       this.#qtyDiscountFetch.abort();
//     }

//     const abortController = new AbortController();
//     this.#qtyDiscountFetch = abortController;

//     try {
//       const sectionsToUpdate = this.#sectionsToUpdate();
//       const config = fetchConfig('json', {
//         body: JSON.stringify({
//           discount: nextCodes.join(','),
//           sections: sectionsToUpdate.join(','),
//           sections_url: window.location.pathname,
//         }),
//       });

//       const response = await fetch(Theme.routes.cart_update_url, {
//         ...config,
//         signal: abortController.signal,
//       });

//       const data = await response.json();

//       if (qualifies) {
//         const applied = data.discount_codes?.find(
//           (/** @type {{ code: string; applicable: boolean }} */ discount) =>
//             discount.code.toLowerCase() === discountCode.toLowerCase()
//         );

//         if (!applied?.applicable) {
//           console.warn(
//             `[cart] Quantity discount code "${discountCode}" could not be applied. Create a matching discount in Shopify Admin.`
//           );
//           return;
//         }
//       }

//       document.dispatchEvent(new DiscountUpdateEvent(data, this.id));

//       for (const sectionId of sectionsToUpdate) {
//         const sectionHtml = data.sections?.[sectionId];
//         if (sectionHtml) {
//           morphSection(sectionId, sectionHtml, { mode: this.isDrawer ? 'hydration' : 'full' });
//         }
//       }

//       this.#updateCartQuantitySelectorButtonStates();
//     } catch (error) {
//       if (error instanceof DOMException && error.name === 'AbortError') return;
//       console.error(error);
//     } finally {
//       if (this.#qtyDiscountFetch === abortController) {
//         this.#qtyDiscountFetch = null;
//       }
//     }
//   }

//   /**
//    * @returns {string[]}
//    */
//   #sectionsToUpdate() {
//     const sectionsToUpdate = new Set([this.sectionId]);
//     document.querySelectorAll('cart-items-component').forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });
//     return Array.from(sectionsToUpdate);
//   }

//   /**
//    * Handles the discount update.
//    * @param {DiscountUpdateEvent} event - The event.
//    */
//   handleDiscountUpdate = (event) => {
//     this.#handleCartUpdate(event);
//   };

//   /**
//    * Handles the cart error.
//    * @param {number} line - The line.
//    * @param {Object} parsedResponseText - The parsed response text.
//    * @param {string} parsedResponseText.errors - The errors.
//    */
//   #handleCartError = (line, parsedResponseText) => {
//     const quantitySelector = this.refs.quantitySelectors[line - 1];
//     const quantityInput = quantitySelector?.querySelector('input');

//     if (!quantityInput) throw new Error('Quantity input not found');

//     quantityInput.value = quantityInput.defaultValue;

//     const cartItemError = this.refs[`cartItemError-${line}`];
//     const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

//     if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
//     if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

//     cartItemError.textContent = parsedResponseText.errors;
//     cartItemErrorContainer.classList.remove('hidden');
//   };

//   /**
//    * Handles the cart update.
//    *
//    * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
//    */
//   #handleCartUpdate = (event) => {
//     if (event instanceof DiscountUpdateEvent) {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//       return;
//     }
//     if (event.target === this) return;

//     const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
//     if (cartItemsHtml) {
//       morphSection(this.sectionId, cartItemsHtml);

//       // Update button states for all cart quantity selectors after morph
//       this.#updateCartQuantitySelectorButtonStates();
//     } else {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//     }
//   };

//   /**
//    * Disables the cart items.
//    */
//   #disableCartItems() {
//     this.classList.add('cart-items-disabled');
//   }

//   /**
//    * Enables the cart items.
//    */
//   #enableCartItems() {
//     this.classList.remove('cart-items-disabled');
//   }

//   /**
//    * Updates quantity selectors for all matching variants in the cart.
//    * @param {Object} updatedCart - The updated cart object.
//    * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
//    */
//   #updateQuantitySelectors(updatedCart) {
//     if (!updatedCart.items) return;

//     for (const item of updatedCart.items) {
//       const variantId = item.variant_id.toString();
//       const selectors = document.querySelectorAll(`quantity-selector-component[data-variant-id="${variantId}"]`);

//       for (const selector of selectors) {
//         const input = selector.querySelector('input[data-cart-quantity]');
//         if (!input) continue;

//         input.setAttribute('data-cart-quantity', item.quantity.toString());

//         // Update the quantity selector's internal state
//         if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
//           selector.updateCartQuantity();
//         }
//       }
//     }
//   }

//   /**
//    * Updates button states for all cart quantity selector components.
//    */
//   #updateCartQuantitySelectorButtonStates() {
//     for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
//       /** @type {any} */ (selector).updateButtonStates?.();
//     }
//   }

//   /**
//    * Gets the section id.
//    * @returns {string} The section id.
//    */
//   get sectionId() {
//     const { sectionId } = this.dataset;

//     if (!sectionId) throw new Error('Section id missing');

//     return sectionId;
//   }

//   /**
//    * @returns {boolean} Whether the component is a drawer.
//    */
//   get isDrawer() {
//     return this.dataset.drawer !== undefined;
//   }
// }

// if (!customElements.get('cart-items-component')) {
//   customElements.define('cart-items-component', CartItemsComponent);
// }


// import { Component } from '@theme/component';
// import {
//   fetchConfig,
//   debounce,
//   onAnimationEnd,
//   prefersReducedMotion,
//   resetShimmer,
//   startViewTransition,
// } from '@theme/utilities';
// import { morphSection, sectionRenderer } from '@theme/section-renderer';
// import {
//   ThemeEvents,
//   CartUpdateEvent,
//   QuantitySelectorUpdateEvent,
//   CartAddEvent,
//   DiscountUpdateEvent,
// } from '@theme/events';
// import { cartPerformance } from '@theme/performance';

// /** @typedef {import('./utilities').TextComponent} TextComponent */

// /**
//  * A custom element that displays a cart items component.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
//  * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
//  * @property {TextComponent} cartTotal - The cart total.
//  *
//  * @extends {Component<Refs>}
//  */
// class CartItemsComponent extends Component {
//   #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

//   connectedCallback() {
//     super.connectedCallback();

//     document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.removeEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   /**
//    * Handles QuantitySelectorUpdateEvent change event.
//    * @param {QuantitySelectorUpdateEvent} event - The event.
//    */
//   #onQuantityChange(event) {
//     if (!(event.target instanceof Node) || !this.contains(event.target)) return;

//     const { quantity, cartLine: line } = event.detail;

//     // Cart items require a line number
//     if (!line) return;

//     if (quantity === 0) {
//       return this.onLineItemRemove(line);
//     }

//     this.updateQuantity({
//       line,
//       quantity,
//       action: 'change',
//     });
//     const lineItemRow = this.refs.cartItemRows[line - 1];

//     if (!lineItemRow) return;

//     const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
//     textComponent?.shimmer();
//   }

//   /**
//    * Handles the line item removal.
//    * @param {number} line - The line item index.
//    */
//   onLineItemRemove(line) {
//     this.updateQuantity({
//       line,
//       quantity: 0,
//       action: 'clear',
//     });

//     const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

//     if (!cartItemRowToRemove) return;

//     const rowsToRemove = [
//       cartItemRowToRemove,
//       // Get all nested lines of the row to remove
//       ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
//     ];

//     // If the cart item row is the last row, optimistically trigger the cart empty state
//     const isEmptyCart = rowsToRemove.length == this.refs.cartItemRows.length;

//     const template = document.getElementById('empty-cart-template');
//     if (isEmptyCart && template instanceof HTMLTemplateElement) {
//       const clone = document.importNode(template.content, true);

//       startViewTransition(() => {
//         this.replaceChildren(clone);
//       }, [this.isDrawer ? 'empty-cart-drawer' : 'empty-cart-page']);

//       return;
//     }

//     // Add class to the row to trigger the animation
//     rowsToRemove.forEach((row) => {
//       const remove = () => row.remove();

//       if (prefersReducedMotion()) return remove();

//       row.style.setProperty('--row-height', `${row.clientHeight}px`);
//       row.classList.add('removing');

//       // Remove the row after the animation ends
//       onAnimationEnd(row, remove);
//     });
//   }

//   /**
//    * Updates the quantity.
//    * @param {Object} config - The config.
//    * @param {number} config.line - The line.
//    * @param {number} config.quantity - The quantity.
//    * @param {string} config.action - The action.
//    */
//   updateQuantity(config) {
//     const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

//     this.#disableCartItems();

//     const { line, quantity } = config;
//     const { cartTotal } = this.refs;

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     const sectionsToUpdate = new Set([this.sectionId]);
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });

//     const body = JSON.stringify({
//       line: line,
//       quantity: quantity,
//       sections: Array.from(sectionsToUpdate).join(','),
//       sections_url: window.location.pathname,
//     });

//     cartTotal?.shimmer();

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then((response) => {
//         return response.text();
//       })
//       .then((responseText) => {
//         const parsedResponseText = JSON.parse(responseText);

//         resetShimmer(this);

//         if (parsedResponseText.errors) {
//           this.#handleCartError(line, parsedResponseText);
//           return;
//         }

//         const newSectionHTML = new DOMParser().parseFromString(
//           parsedResponseText.sections[this.sectionId],
//           'text/html'
//         );

//         // Grab the new cart item count from a hidden element
//         const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
//         const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

//         // Update data-cart-quantity for all matching variants
//         this.#updateQuantitySelectors(parsedResponseText);

//         this.dispatchEvent(
//           new CartUpdateEvent(parsedResponseText, this.sectionId, {
//             itemCount: newCartItemCount,
//             source: 'cart-items-component',
//             sections: parsedResponseText.sections,
//           })
//         );

//         morphSection(this.sectionId, parsedResponseText.sections[this.sectionId], { mode: this.isDrawer ? 'hydration' : 'full' });

//         this.#updateCartQuantitySelectorButtonStates();
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         this.#enableCartItems();
//         cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
//       });
//   }

//   /**
//    * Handles the discount update.
//    * @param {DiscountUpdateEvent} event - The event.
//    */
//   handleDiscountUpdate = (event) => {
//     this.#handleCartUpdate(event);
//   };

//   /**
//    * Handles the cart error.
//    * @param {number} line - The line.
//    * @param {Object} parsedResponseText - The parsed response text.
//    * @param {string} parsedResponseText.errors - The errors.
//    */
//   #handleCartError = (line, parsedResponseText) => {
//     const quantitySelector = this.refs.quantitySelectors[line - 1];
//     const quantityInput = quantitySelector?.querySelector('input');

//     if (!quantityInput) throw new Error('Quantity input not found');

//     quantityInput.value = quantityInput.defaultValue;

//     const cartItemError = this.refs[`cartItemError-${line}`];
//     const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

//     if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
//     if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

//     cartItemError.textContent = parsedResponseText.errors;
//     cartItemErrorContainer.classList.remove('hidden');
//   };

//   /**
//    * Handles the cart update.
//    *
//    * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
//    */
//   #handleCartUpdate = (event) => {
//     if (event instanceof DiscountUpdateEvent) {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//       return;
//     }
//     if (event.target === this) return;

//     const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
//     if (cartItemsHtml) {
//       morphSection(this.sectionId, cartItemsHtml);

//       // Update button states for all cart quantity selectors after morph
//       this.#updateCartQuantitySelectorButtonStates();
//     } else {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//     }
//   };

//   /**
//    * Disables the cart items.
//    */
//   #disableCartItems() {
//     this.classList.add('cart-items-disabled');
//   }

//   /**
//    * Enables the cart items.
//    */
//   #enableCartItems() {
//     this.classList.remove('cart-items-disabled');
//   }

//   /**
//    * Updates quantity selectors for all matching variants in the cart.
//    * @param {Object} updatedCart - The updated cart object.
//    * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
//    */
//   #updateQuantitySelectors(updatedCart) {
//     if (!updatedCart.items) return;

//     for (const item of updatedCart.items) {
//       const variantId = item.variant_id.toString();
//       const selectors = document.querySelectorAll(`quantity-selector-component[data-variant-id="${variantId}"]`);

//       for (const selector of selectors) {
//         const input = selector.querySelector('input[data-cart-quantity]');
//         if (!input) continue;

//         input.setAttribute('data-cart-quantity', item.quantity.toString());

//         // Update the quantity selector's internal state
//         if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
//           selector.updateCartQuantity();
//         }
//       }
//     }
//   }

//   /**
//    * Updates button states for all cart quantity selector components.
//    */
//   #updateCartQuantitySelectorButtonStates() {
//     for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
//       /** @type {any} */ (selector).updateButtonStates?.();
//     }
//   }

//   /**
//    * Gets the section id.
//    * @returns {string} The section id.
//    */
//   get sectionId() {
//     const { sectionId } = this.dataset;

//     if (!sectionId) throw new Error('Section id missing');

//     return sectionId;
//   }

//   /**
//    * @returns {boolean} Whether the component is a drawer.
//    */
//   get isDrawer() {
//     return this.dataset.drawer !== undefined;
//   }
// }

// if (!customElements.get('cart-items-component')) {
//   customElements.define('cart-items-component', CartItemsComponent);
// }


// import { Component } from '@theme/component';
// import {
//   fetchConfig,
//   debounce,
//   onAnimationEnd,
//   prefersReducedMotion,
//   resetShimmer,
//   startViewTransition,
// } from '@theme/utilities';
// import { morphSection, sectionRenderer } from '@theme/section-renderer';
// import {
//   ThemeEvents,
//   CartUpdateEvent,
//   QuantitySelectorUpdateEvent,
//   CartAddEvent,
//   DiscountUpdateEvent,
// } from '@theme/events';
// import { cartPerformance } from '@theme/performance';

// /** @typedef {import('./utilities').TextComponent} TextComponent */

// /**
//  * A custom element that displays a cart items component.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
//  * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
//  * @property {TextComponent} cartTotal - The cart total.
//  *
//  * @extends {Component<Refs>}
//  */
// class CartItemsComponent extends Component {
//   #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

//   /** @type {AbortController | null} */
//   #qtyDiscountFetch = null;

//   connectedCallback() {
//     super.connectedCallback();

//     document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.removeEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//     this.#qtyDiscountFetch?.abort();
//   }

//   /**
//    * Handles QuantitySelectorUpdateEvent change event.
//    * @param {QuantitySelectorUpdateEvent} event - The event.
//    */
//   #onQuantityChange(event) {
//     if (!(event.target instanceof Node) || !this.contains(event.target)) return;

//     const { quantity, cartLine: line } = event.detail;

//     // Cart items require a line number
//     if (!line) return;

//     if (quantity === 0) {
//       return this.onLineItemRemove(line);
//     }

//     this.updateQuantity({
//       line,
//       quantity,
//       action: 'change',
//     });
//     const lineItemRow = this.refs.cartItemRows[line - 1];

//     if (!lineItemRow) return;

//     const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
//     textComponent?.shimmer();
//   }

//   /**
//    * Handles the line item removal.
//    * @param {number} line - The line item index.
//    */
//   onLineItemRemove(line) {
//     this.updateQuantity({
//       line,
//       quantity: 0,
//       action: 'clear',
//     });

//     const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

//     if (!cartItemRowToRemove) return;

//     const rowsToRemove = [
//       cartItemRowToRemove,
//       // Get all nested lines of the row to remove
//       ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
//     ];

//     // If the cart item row is the last row, optimistically trigger the cart empty state
//     const isEmptyCart = rowsToRemove.length == this.refs.cartItemRows.length;

//     const template = document.getElementById('empty-cart-template');
//     if (isEmptyCart && template instanceof HTMLTemplateElement) {
//       const clone = document.importNode(template.content, true);

//       startViewTransition(() => {
//         this.replaceChildren(clone);
//       }, [this.isDrawer ? 'empty-cart-drawer' : 'empty-cart-page']);

//       return;
//     }

//     // Add class to the row to trigger the animation
//     rowsToRemove.forEach((row) => {
//       const remove = () => row.remove();

//       if (prefersReducedMotion()) return remove();

//       row.style.setProperty('--row-height', `${row.clientHeight}px`);
//       row.classList.add('removing');

//       // Remove the row after the animation ends
//       onAnimationEnd(row, remove);
//     });
//   }

//   /**
//    * Updates the quantity.
//    * @param {Object} config - The config.
//    * @param {number} config.line - The line.
//    * @param {number} config.quantity - The quantity.
//    * @param {string} config.action - The action.
//    */
//   updateQuantity(config) {
//     const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

//     this.#disableCartItems();

//     const { line, quantity } = config;
//     const { cartTotal } = this.refs;

//     const sectionsToUpdate = this.#sectionsToUpdate();

//     const body = JSON.stringify({
//       line: line,
//       quantity: quantity,
//       sections: sectionsToUpdate.join(','),
//       sections_url: window.location.pathname,
//     });

//     cartTotal?.shimmer();

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then((response) => {
//         return response.text();
//       })
//       .then(async (responseText) => {
//         const parsedResponseText = JSON.parse(responseText);

//         resetShimmer(this);

//         if (parsedResponseText.errors) {
//           this.#handleCartError(line, parsedResponseText);
//           return;
//         }

//         const newSectionHTML = new DOMParser().parseFromString(
//           parsedResponseText.sections[this.sectionId],
//           'text/html'
//         );

//         // Grab the new cart item count from a hidden element
//         const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
//         const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

//         // Update data-cart-quantity for all matching variants
//         this.#updateQuantitySelectors(parsedResponseText);

//         this.dispatchEvent(
//           new CartUpdateEvent(parsedResponseText, this.sectionId, {
//             itemCount: newCartItemCount,
//             source: 'cart-items-component',
//             sections: parsedResponseText.sections,
//           })
//         );

//         morphSection(this.sectionId, parsedResponseText.sections[this.sectionId], {
//           mode: this.isDrawer ? 'hydration' : 'full',
//         });

//         this.#updateCartQuantitySelectorButtonStates();

//         await this.#syncQuantityDiscount(parsedResponseText);
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         this.#enableCartItems();
//         cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
//       });
//   }

//   /**
//    * Applies or removes the multi-quantity discount code based on cart line quantities.
//    * @param {Object} cart - The cart payload from /cart/change.js
//    * @param {Array<{quantity: number}>} [cart.items]
//    * @param {Array<{code: string, applicable: boolean}>} [cart.discount_codes]
//    */
//   async #syncQuantityDiscount(cart) {
//     if (this.dataset.qtyDiscountEnabled !== 'true') return;

//     const discountCode = this.dataset.qtyDiscountCode?.trim();
//     if (!discountCode) return;

//     const threshold = parseInt(this.dataset.qtyDiscountThreshold || '2', 10);
//     const excludedProductIds = new Set(
//       (this.dataset.qtyDiscountExcludedProducts || '')
//         .split(',')
//         .map((id) => id.trim())
//         .filter(Boolean)
//     );
//     const qualifies =
//       Array.isArray(cart.items) &&
//       cart.items.some((item) => {
//         const variantTitle = (item.variant_title || '').toLowerCase().trim();
//         const excludedVariant = variantTitle === '2 bottle' || variantTitle === '3 bottle';
//         const excludedProduct = excludedProductIds.has(String(item.product_id));
//         return !excludedVariant && !excludedProduct && item.quantity >= threshold;
//       });

//     /** @type {string[]} */
//     const existingCodes = (cart.discount_codes || [])
//       .filter((discount) => discount.applicable)
//       .map((discount) => discount.code);

//     const codeIndex = existingCodes.findIndex((code) => code.toLowerCase() === discountCode.toLowerCase());
//     const hasCode = codeIndex !== -1;

//     if (qualifies && hasCode) return;
//     if (!qualifies && !hasCode) return;

//     /** @type {string[]} */
//     let nextCodes;
//     if (qualifies) {
//       nextCodes = [...existingCodes, discountCode];
//     } else {
//       nextCodes = existingCodes.filter((_, index) => index !== codeIndex);
//     }

//     if (this.#qtyDiscountFetch) {
//       this.#qtyDiscountFetch.abort();
//     }

//     const abortController = new AbortController();
//     this.#qtyDiscountFetch = abortController;

//     try {
//       const sectionsToUpdate = this.#sectionsToUpdate();
//       const config = fetchConfig('json', {
//         body: JSON.stringify({
//           discount: nextCodes.join(','),
//           sections: sectionsToUpdate.join(','),
//           sections_url: window.location.pathname,
//         }),
//       });

//       const response = await fetch(Theme.routes.cart_update_url, {
//         ...config,
//         signal: abortController.signal,
//       });

//       const data = await response.json();

//       if (qualifies) {
//         const applied = data.discount_codes?.find(
//           (/** @type {{ code: string; applicable: boolean }} */ discount) =>
//             discount.code.toLowerCase() === discountCode.toLowerCase()
//         );

//         if (!applied?.applicable) {
//           console.warn(
//             `[cart] Quantity discount code "${discountCode}" could not be applied. Create a matching discount in Shopify Admin.`
//           );
//           return;
//         }
//       }

//       document.dispatchEvent(new DiscountUpdateEvent(data, this.id));

//       for (const sectionId of sectionsToUpdate) {
//         const sectionHtml = data.sections?.[sectionId];
//         if (sectionHtml) {
//           morphSection(sectionId, sectionHtml, { mode: this.isDrawer ? 'hydration' : 'full' });
//         }
//       }

//       this.#updateCartQuantitySelectorButtonStates();
//     } catch (error) {
//       if (error instanceof DOMException && error.name === 'AbortError') return;
//       console.error(error);
//     } finally {
//       if (this.#qtyDiscountFetch === abortController) {
//         this.#qtyDiscountFetch = null;
//       }
//     }
//   }

//   /**
//    * @returns {string[]}
//    */
//   #sectionsToUpdate() {
//     const sectionsToUpdate = new Set([this.sectionId]);
//     document.querySelectorAll('cart-items-component').forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });
//     return Array.from(sectionsToUpdate);
//   }

//   /**
//    * Handles the discount update.
//    * @param {DiscountUpdateEvent} event - The event.
//    */
//   handleDiscountUpdate = (event) => {
//     this.#handleCartUpdate(event);
//   };

//   /**
//    * Handles the cart error.
//    * @param {number} line - The line.
//    * @param {Object} parsedResponseText - The parsed response text.
//    * @param {string} parsedResponseText.errors - The errors.
//    */
//   #handleCartError = (line, parsedResponseText) => {
//     const quantitySelector = this.refs.quantitySelectors[line - 1];
//     const quantityInput = quantitySelector?.querySelector('input');

//     if (!quantityInput) throw new Error('Quantity input not found');

//     quantityInput.value = quantityInput.defaultValue;

//     const cartItemError = this.refs[`cartItemError-${line}`];
//     const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

//     if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
//     if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

//     cartItemError.textContent = parsedResponseText.errors;
//     cartItemErrorContainer.classList.remove('hidden');
//   };

//   /**
//    * Handles the cart update.
//    *
//    * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
//    */
//   #handleCartUpdate = (event) => {
//     if (event instanceof DiscountUpdateEvent) {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//       return;
//     }
//     if (event.target === this) return;

//     const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
//     if (cartItemsHtml) {
//       morphSection(this.sectionId, cartItemsHtml);

//       // Update button states for all cart quantity selectors after morph
//       this.#updateCartQuantitySelectorButtonStates();
//     } else {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//     }
//   };

//   /**
//    * Disables the cart items.
//    */
//   #disableCartItems() {
//     this.classList.add('cart-items-disabled');
//   }

//   /**
//    * Enables the cart items.
//    */
//   #enableCartItems() {
//     this.classList.remove('cart-items-disabled');
//   }

//   /**
//    * Updates quantity selectors for all matching variants in the cart.
//    * @param {Object} updatedCart - The updated cart object.
//    * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
//    */
//   #updateQuantitySelectors(updatedCart) {
//     if (!updatedCart.items) return;

//     for (const item of updatedCart.items) {
//       const variantId = item.variant_id.toString();
//       const selectors = document.querySelectorAll(`quantity-selector-component[data-variant-id="${variantId}"]`);

//       for (const selector of selectors) {
//         const input = selector.querySelector('input[data-cart-quantity]');
//         if (!input) continue;

//         input.setAttribute('data-cart-quantity', item.quantity.toString());

//         // Update the quantity selector's internal state
//         if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
//           selector.updateCartQuantity();
//         }
//       }
//     }
//   }

//   /**
//    * Updates button states for all cart quantity selector components.
//    */
//   #updateCartQuantitySelectorButtonStates() {
//     for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
//       /** @type {any} */ (selector).updateButtonStates?.();
//     }
//   }

//   /**
//    * Gets the section id.
//    * @returns {string} The section id.
//    */
//   get sectionId() {
//     const { sectionId } = this.dataset;

//     if (!sectionId) throw new Error('Section id missing');

//     return sectionId;
//   }

//   /**
//    * @returns {boolean} Whether the component is a drawer.
//    */
//   get isDrawer() {
//     return this.dataset.drawer !== undefined;
//   }
// }

// if (!customElements.get('cart-items-component')) {
//   customElements.define('cart-items-component', CartItemsComponent);
// }


import { Component } from '@theme/component';
import {
  fetchConfig,
  debounce,
  onAnimationEnd,
  prefersReducedMotion,
  resetShimmer,
  startViewTransition,
} from '@theme/utilities';
import { morphSection, sectionRenderer } from '@theme/section-renderer';
import {
  ThemeEvents,
  CartUpdateEvent,
  QuantitySelectorUpdateEvent,
  CartAddEvent,
  DiscountUpdateEvent,
} from '@theme/events';
import { cartPerformance } from '@theme/performance';

/** @typedef {import('./utilities').TextComponent} TextComponent */

/**
 * A custom element that displays a cart items component.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
 * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
 * @property {TextComponent} cartTotal - The cart total.
 *
 * @extends {Component<Refs>}
 */
class CartItemsComponent extends Component {
  #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);

    // Sync pack÷3 pricing into the real cart (needed for Shopify checkout)
    requestAnimationFrame(() => {
      this.ensureMonthTierForCheckout({ refresh: true }).catch(() => {});
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    document.removeEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
    document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
  }

  /**
   * Handles QuantitySelectorUpdateEvent change event.
   * @param {QuantitySelectorUpdateEvent} event - The event.
   */
  #onQuantityChange(event) {
    if (!(event.target instanceof Node) || !this.contains(event.target)) return;

    const { quantity, cartLine: line } = event.detail;

    // Cart items require a line number
    if (!line) return;

    if (quantity === 0) {
      return this.onLineItemRemove(line);
    }

    const lineItemRow = this.refs.cartItemRows[line - 1];
    const isMonthTier = lineItemRow?.hasAttribute('data-month-tier');

    if (isMonthTier) {
      this.#updateMonthTierQuantity({
        line,
        quantity,
        row: lineItemRow,
      }).catch(() => {});
      return;
    }

    this.updateQuantity({
      line,
      quantity,
      action: 'change',
    });

    if (!lineItemRow) return;

    const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
    textComponent?.shimmer();
  }

  /**
   * Make sure qty 3+ lines use Bulk Month (pack÷3) in the real Shopify cart
   * so checkout totals match the cart page. Safe to call before checkout.
   *
   * @param {{ refresh?: boolean }} [options]
   * @returns {Promise<boolean>} true if the cart was modified
   */
  async ensureMonthTierForCheckout(options = {}) {
    const { refresh = false } = options;
    const cartUrl = Theme.routes.cart_url.includes('.js')
      ? Theme.routes.cart_url
      : `${Theme.routes.cart_url}.js`;
    const changeUrl = Theme.routes.cart_change_url.includes('.js')
      ? Theme.routes.cart_change_url
      : `${Theme.routes.cart_change_url}.js`;
    const addUrl = Theme.routes.cart_add_url.includes('.js')
      ? Theme.routes.cart_add_url
      : `${Theme.routes.cart_add_url}.js`;

    /** @type {Map<string, { one: number, bulk: number, three?: number }>} */
    const productMap = new Map();

    const mapEl = document.getElementById('MonthTierVariantMap');
    if (mapEl?.textContent) {
      try {
        const parsed = JSON.parse(mapEl.textContent);
        for (const [productId, value] of Object.entries(parsed || {})) {
          const one = Number(value?.one);
          const bulk = Number(value?.bulk);
          const three = Number(value?.three);
          if (productId && one && bulk) productMap.set(String(productId), { one, bulk, three });
        }
      } catch (error) {
        console.error(error);
      }
    }

    for (const row of document.querySelectorAll('[data-month-tier][data-bulk-month-id][data-one-month-id]')) {
      if (!(row instanceof HTMLElement)) continue;
      const productId = String(row.dataset.productId || '');
      const one = Number(row.dataset.oneMonthId);
      const bulk = Number(row.dataset.bulkMonthId);
      const three = Number(row.dataset.threeMonthId);
      if (!productId || !one || !bulk) continue;
      productMap.set(productId, { one, bulk, three });
    }

    if (!productMap.size) return false;

    const cart = await fetch(cartUrl).then((r) => r.json());
    if (!cart?.items?.length) return false;

    let changed = false;

    // Work backwards so line removals don't shift earlier indices
    for (let i = cart.items.length - 1; i >= 0; i--) {
      const item = cart.items[i];
      const map = productMap.get(String(item.product_id));
      if (!map) continue;

      const variantId = Number(item.id);
      const qty = Number(item.quantity) || 0;
      const isMonthlyTier = item.properties?._month_tier === 'monthly';

      // Only manage the 1 Month / Bulk Month path.
      // Legacy: 3 Month lines created by the old qty-3 pack conversion → expand back to bottles on Bulk.
      let bottleQty = null;
      if (variantId === map.one || variantId === map.bulk) {
        bottleQty = qty;
      } else if (variantId === map.three && isMonthlyTier) {
        bottleQty = qty * 3;
      } else {
        continue;
      }

      let targetId = map.one;
      let targetQty = bottleQty;
      if (bottleQty >= 3) {
        targetId = map.bulk;
        targetQty = bottleQty;
      }

      if (targetId === variantId && targetQty === qty) continue;

      const addPayload = {
        id: targetId,
        quantity: targetQty,
      };
      if (targetId === map.bulk) {
        addPayload.properties = { _month_tier: 'monthly' };
      }

      const addResponse = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [addPayload] }),
      });
      const addJson = await addResponse.json();
      if (addJson.status && addJson.status >= 400) {
        console.error(addJson.description || addJson.message || addJson);
        continue;
      }

      const removeResponse = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
      const removeJson = await removeResponse.json();
      if (removeJson.errors) continue;

      changed = true;
    }

    if (changed && refresh) {
      await sectionRenderer.renderSection(this.sectionId, { cache: false });
    }

    return changed;
  }

  /**
   * @deprecated kept for quantity-change path; prefer ensureMonthTierForCheckout on load
   */
  #reconcileMonthTierLines() {
    this.ensureMonthTierForCheckout({ refresh: true }).catch(() => {});
  }

  /**
   * 1–2: 1 Month. 3+: Bulk Month at same bottle qty (pack÷3 unit). Never use 3 Month packs
   * here — that caused qty 3 to become 9 on checkout.
   *
   * @param {{ line: number, quantity: number, row: HTMLElement }} config
   */
  async #updateMonthTierQuantity(config) {
    const { line, quantity, row } = config;
    const oneMonthId = row.dataset.oneMonthId;
    const threeMonthId = row.dataset.threeMonthId;
    const bulkMonthId = row.dataset.bulkMonthId;
    const variantTitle = (row.dataset.variantTitle || '').toLowerCase().trim();

    if (!oneMonthId || !threeMonthId) {
      this.updateQuantity({ line, quantity, action: 'change' });
      return;
    }

    // Explicit 3 Month pack purchase — leave alone
    if (variantTitle === '3 month') {
      this.updateQuantity({ line, quantity, action: 'change' });
      return;
    }

    if (!bulkMonthId) {
      this.updateQuantity({ line, quantity, action: 'change' });
      return;
    }

    const bottleQty = quantity;
    const targetVariantId = bottleQty >= 3 ? bulkMonthId : oneMonthId;
    const targetQty = bottleQty;

    const currentIsTarget =
      (bottleQty >= 3 && variantTitle === 'bulk month') ||
      (bottleQty < 3 && variantTitle === '1 month');

    if (currentIsTarget) {
      this.updateQuantity({ line, quantity: targetQty, action: 'change' });
      return;
    }

    // Need to swap variant: ADD first, then remove — never leave cart empty if add fails
    const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker('change:user-action');
    this.#disableCartItems();
    const { cartTotal } = this.refs;
    cartTotal?.shimmer();

    const sectionsToUpdate = this.#sectionsToUpdate();
    const lineKey = row.dataset.key;

    try {
      const addUrl = Theme.routes.cart_add_url.includes('.js')
        ? Theme.routes.cart_add_url
        : `${Theme.routes.cart_add_url}.js`;
      const itemPayload = {
        id: Number(targetVariantId),
        quantity: targetQty,
      };
      if (bottleQty >= 3) {
        itemPayload.properties = { _month_tier: 'monthly' };
      }
      const addBody = JSON.stringify({
        items: [itemPayload],
        sections: sectionsToUpdate.join(','),
        sections_url: window.location.pathname,
      });
      const addResponse = await fetch(addUrl, fetchConfig('json', { body: addBody }));
      const addJson = await addResponse.json();

      if (addJson.status && addJson.status >= 400) {
        console.error(addJson.description || addJson.message || addJson);
        this.updateQuantity({ line, quantity: targetQty, action: 'change' });
        return;
      }

      const changeUrl = Theme.routes.cart_change_url.includes('.js')
        ? Theme.routes.cart_change_url
        : `${Theme.routes.cart_change_url}.js`;
      const removeBody = JSON.stringify({
        id: lineKey,
        quantity: 0,
        sections: sectionsToUpdate.join(','),
        sections_url: window.location.pathname,
      });
      const removeResponse = await fetch(changeUrl, fetchConfig('json', { body: removeBody }));
      const removeText = await removeResponse.text();
      const removeJson = JSON.parse(removeText);
      if (removeJson.errors) {
        this.#handleCartError(line, removeJson);
        return;
      }

      resetShimmer(this);

      const sectionHtml = removeJson.sections?.[this.sectionId] || addJson.sections?.[this.sectionId];
      const itemCount =
        typeof removeJson.item_count === 'number'
          ? removeJson.item_count
          : addJson.item_count;

      this.#updateQuantitySelectors(removeJson);

      this.dispatchEvent(
        new CartUpdateEvent(removeJson, this.sectionId, {
          itemCount,
          source: 'cart-items-component',
          sections: removeJson.sections,
        })
      );

      if (sectionHtml) {
        morphSection(this.sectionId, sectionHtml, {
          mode: this.isDrawer ? 'hydration' : 'full',
        });
      } else {
        sectionRenderer.renderSection(this.sectionId, { cache: false });
      }

      this.#updateCartQuantitySelectorButtonStates();
    } catch (error) {
      console.error(error);
      sectionRenderer.renderSection(this.sectionId, { cache: false });
    } finally {
      this.#enableCartItems();
      cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
    }
  }

  /**
   * Handles the line item removal.
   * @param {number} line - The line item index.
   */
  onLineItemRemove(line) {
    this.updateQuantity({
      line,
      quantity: 0,
      action: 'clear',
    });

    const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

    if (!cartItemRowToRemove) return;

    const rowsToRemove = [
      cartItemRowToRemove,
      // Get all nested lines of the row to remove
      ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
    ];

    // If the cart item row is the last row, optimistically trigger the cart empty state
    const isEmptyCart = rowsToRemove.length == this.refs.cartItemRows.length;

    const template = document.getElementById('empty-cart-template');
    if (isEmptyCart && template instanceof HTMLTemplateElement) {
      const clone = document.importNode(template.content, true);

      startViewTransition(() => {
        this.replaceChildren(clone);
      }, [this.isDrawer ? 'empty-cart-drawer' : 'empty-cart-page']);

      return;
    }

    // Add class to the row to trigger the animation
    rowsToRemove.forEach((row) => {
      const remove = () => row.remove();

      if (prefersReducedMotion()) return remove();

      row.style.setProperty('--row-height', `${row.clientHeight}px`);
      row.classList.add('removing');

      // Remove the row after the animation ends
      onAnimationEnd(row, remove);
    });
  }

  /**
   * Updates the quantity.
   * @param {Object} config - The config.
   * @param {number} config.line - The line.
   * @param {number} config.quantity - The quantity.
   * @param {string} config.action - The action.
   */
  updateQuantity(config) {
    const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

    this.#disableCartItems();

    const { line, quantity } = config;
    const { cartTotal } = this.refs;

    const sectionsToUpdate = this.#sectionsToUpdate();

    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: sectionsToUpdate.join(','),
      sections_url: window.location.pathname,
    });

    cartTotal?.shimmer();

    fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const parsedResponseText = JSON.parse(responseText);

        resetShimmer(this);

        if (parsedResponseText.errors) {
          this.#handleCartError(line, parsedResponseText);
          return;
        }

        const newSectionHTML = new DOMParser().parseFromString(
          parsedResponseText.sections[this.sectionId],
          'text/html'
        );

        // Grab the new cart item count from a hidden element
        const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
        const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

        // Update data-cart-quantity for all matching variants
        this.#updateQuantitySelectors(parsedResponseText);

        this.dispatchEvent(
          new CartUpdateEvent(parsedResponseText, this.sectionId, {
            itemCount: newCartItemCount,
            source: 'cart-items-component',
            sections: parsedResponseText.sections,
          })
        );

        morphSection(this.sectionId, parsedResponseText.sections[this.sectionId], {
          mode: this.isDrawer ? 'hydration' : 'full',
        });

        this.#updateCartQuantitySelectorButtonStates();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.#enableCartItems();
        cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
      });
  }

  /**
   * @returns {string[]}
   */
  #sectionsToUpdate() {
    const sectionsToUpdate = new Set([this.sectionId]);
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToUpdate.add(item.dataset.sectionId);
      }
    });
    return Array.from(sectionsToUpdate);
  }

  /**
   * Handles the discount update.
   * @param {DiscountUpdateEvent} event - The event.
   */
  handleDiscountUpdate = (event) => {
    this.#handleCartUpdate(event);
  };

  /**
   * Handles the cart error.
   * @param {number} line - The line.
   * @param {Object} parsedResponseText - The parsed response text.
   * @param {string} parsedResponseText.errors - The errors.
   */
  #handleCartError = (line, parsedResponseText) => {
    const quantitySelector = this.refs.quantitySelectors[line - 1];
    const quantityInput = quantitySelector?.querySelector('input');

    if (!quantityInput) throw new Error('Quantity input not found');

    quantityInput.value = quantityInput.defaultValue;

    const cartItemError = this.refs[`cartItemError-${line}`];
    const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

    if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
    if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

    cartItemError.textContent = parsedResponseText.errors;
    cartItemErrorContainer.classList.remove('hidden');
  };

  /**
   * Handles the cart update.
   *
   * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
   */
  #handleCartUpdate = (event) => {
    if (event instanceof DiscountUpdateEvent) {
      sectionRenderer.renderSection(this.sectionId, { cache: false });
      return;
    }
    if (event.target === this) return;

    const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
    if (cartItemsHtml) {
      morphSection(this.sectionId, cartItemsHtml);

      // Update button states for all cart quantity selectors after morph
      this.#updateCartQuantitySelectorButtonStates();
    } else {
      sectionRenderer.renderSection(this.sectionId, { cache: false });
    }
  };

  /**
   * Disables the cart items.
   */
  #disableCartItems() {
    this.classList.add('cart-items-disabled');
  }

  /**
   * Enables the cart items.
   */
  #enableCartItems() {
    this.classList.remove('cart-items-disabled');
  }

  /**
   * Updates quantity selectors for all matching variants in the cart.
   * @param {Object} updatedCart - The updated cart object.
   * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
   */
  #updateQuantitySelectors(updatedCart) {
    if (!updatedCart.items) return;

    for (const item of updatedCart.items) {
      const variantId = item.variant_id.toString();
      const selectors = document.querySelectorAll(`quantity-selector-component[data-variant-id="${variantId}"]`);

      for (const selector of selectors) {
        const input = selector.querySelector('input[data-cart-quantity]');
        if (!input) continue;

        input.setAttribute('data-cart-quantity', item.quantity.toString());

        // Update the quantity selector's internal state
        if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
          selector.updateCartQuantity();
        }
      }
    }
  }

  /**
   * Updates button states for all cart quantity selector components.
   */
  #updateCartQuantitySelectorButtonStates() {
    for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
      /** @type {any} */ (selector).updateButtonStates?.();
    }
  }

  /**
   * Gets the section id.
   * @returns {string} The section id.
   */
  get sectionId() {
    const { sectionId } = this.dataset;

    if (!sectionId) throw new Error('Section id missing');

    return sectionId;
  }

  /**
   * @returns {boolean} Whether the component is a drawer.
   */
  get isDrawer() {
    return this.dataset.drawer !== undefined;
  }
}

if (!customElements.get('cart-items-component')) {
  customElements.define('cart-items-component', CartItemsComponent);
}

/**
 * Before leaving for Shopify checkout, sync pack÷3 variants into the real cart.
 * Cart page can show theme prices; checkout only uses real line-item prices.
 */
(() => {
  if (window.__monthTierCheckoutBound) return;
  window.__monthTierCheckoutBound = true;

  let locking = false;

  document.addEventListener(
    'click',
    async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const checkoutBtn = target.closest('#checkout, [name="checkout"], .cart__checkout-button');
      if (!(checkoutBtn instanceof HTMLElement)) return;
      if (checkoutBtn.hasAttribute('disabled')) return;
      if (checkoutBtn.dataset.monthTierSynced === '1') return;

      const cartItems = document.querySelector('cart-items-component');
      if (!(cartItems instanceof CartItemsComponent)) return;
      if (typeof cartItems.ensureMonthTierForCheckout !== 'function') return;

      // Only gate when pack-tier data exists
      const hasTierData =
        document.getElementById('MonthTierVariantMap') ||
        document.querySelector('[data-month-tier][data-bulk-month-id]');
      if (!hasTierData) return;

      event.preventDefault();
      event.stopPropagation();
      if (locking) return;
      locking = true;

      const previousText = checkoutBtn.textContent;
      checkoutBtn.setAttribute('disabled', 'disabled');
      checkoutBtn.setAttribute('aria-busy', 'true');

      try {
        // Don't remorph the page — keep this button node so the second click can proceed
        await cartItems.ensureMonthTierForCheckout({ refresh: false });
        checkoutBtn.dataset.monthTierSynced = '1';
        checkoutBtn.removeAttribute('disabled');
        checkoutBtn.removeAttribute('aria-busy');
        locking = false;
        checkoutBtn.click();
      } catch (error) {
        console.error(error);
        checkoutBtn.removeAttribute('disabled');
        checkoutBtn.removeAttribute('aria-busy');
        if (previousText) checkoutBtn.textContent = previousText;
        locking = false;
      }
    },
    true
  );
})();
